import styled, { css } from 'styled-components';

import { CSSProperties, ReactNode } from 'react';

interface TrProps {
  isEven?: boolean;
  isOdd?: boolean;
  borderBottom?: boolean;
  isRowSelected?: boolean;
  children?: ReactNode;
  onClick?: any;
  style?: CSSProperties;
  className?: string;
  role?: string;
  key?: any;
}

interface TdProps {
  textAlign?: string;
  borderRight?: boolean;
  isRowSelected?: boolean;
  children?: ReactNode;
  style?: CSSProperties;
  className?: string;
  role?: string;
  key?: any;
}

export const Tr = styled.tr<TrProps>`
  cursor: default;
  padding: 0 25px;

  ${({ isEven, theme }) =>
    isEven &&
    css`
      background-color: ${theme.palette.backgrounds.evenRowColor};

      &:hover {
        background-color: ${theme.palette.backgrounds.hoverRow};
      }
    `}

  ${({ isOdd, theme }) =>
    isOdd &&
    css`
      background-color: ${theme.palette.backgrounds.oddRowColor};

      &:hover {
        background-color: ${theme.palette.backgrounds.hoverRow};
      }, 
    `}

  ${({ borderBottom }) =>
    borderBottom &&
    css`
      border-bottom: ${({ theme }) => `1px solid ${theme.palette.tableBorderColor}`};
    `}

    ${({ isRowSelected, theme }) =>
    isRowSelected &&
    css`
      background-color: ${theme.colors.tableSelection};
      color: ${theme.palette.text.secondary};
    `}
`;

export const Td = styled.td<TdProps>`
  padding: 21px 15px;
  vertical-align: top;
  color: ${({ theme }) => theme.palette.neutral.darkest};
  font:
    400 16px/1.2em 'Open Sans',
    sans-serif;
  text-align: ${({ textAlign }) => textAlign};
  position: relative;
  white-space: unset;
  word-break: break-word;

  ${({ borderRight, theme }) =>
    borderRight &&
    css`
      border-right: 1px solid ${theme.palette.tableBorderColorLight};

      :last-child {
        border-right: none;
      }
    `}

  ${({ isRowSelected, theme }) =>
    isRowSelected &&
    css`
      color: ${theme.palette.text.secondary};
    `}
`;
